import { render, staticRenderFns } from "./PrestamoForm.vue?vue&type=template&id=79320c40&scoped=true"
import script from "./PrestamoForm.vue?vue&type=script&lang=js"
export * from "./PrestamoForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./PrestamoForm.vue?vue&type=style&index=2&id=79320c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79320c40",
  null
  
)

export default component.exports